import { Loader } from '@googlemaps/js-api-loader'

export default defineNuxtPlugin(async () => {
  // const runtimeConfig = useRuntimeConfig()
  const nuxtApp = useNuxtApp()

  let GOOGLE_MAPS_API_KEY = nuxtApp.$config.public.googleMapsApiKey

  if (!GOOGLE_MAPS_API_KEY) {
    throw new Error('GOOGLE_MAPS_API_KEY is not set')
  }

  const googleMapsLoader = await new Loader({
    apiKey: GOOGLE_MAPS_API_KEY,
    version: 'weekly',
    libraries: ['places'],
  })

  return {
    provide: {
      googleMapsLoader,
    },
  }
  // Provide the Google Maps API loader as a global property
  // nuxtApp.vueApp.provide("googleMapsLoader", googleMapsLoader);
})
